import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../themes";

export const StyledTextArea = styled.span`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  resize: vertical;
  display: block;
  overflow-wrap: anywhere;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  padding: 10px 8px;
  gap: 8px;
  min-height: 40px;
  background-color: ${colors.general.white};
  border: 1px solid ${colors.border.silver};
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  ${fontSize(14)}
  line-height: 140%;
  text-align: left;
  color: ${colors.text.mineShaft};
  text-wrap: normal;
  :focus {
    border-color: #333333;
    outline: 0;
  }
  @media only screen and ${sizes.max991} {
    min-height: 7.2vh;
    padding: 2vw 1.6vw;
    gap: 1.6vw;  
  }
`;
